import * as api from '../api';

export enum PaymentMethod {
  ApplePay = 'APPLE_PAY',
  NewCreditCard = 'NEW_CREDIT_CARD',
  Paypal = 'PAYPAL',
  SavedCreditCard = 'SAVED_CREDIT_CARD',
}

interface PaymentMessageBase extends api.Assistant.ChatResponse {
  intent: api.Assistant.Intent.Payment;
  disabled?: boolean;
}

export interface PaymentSelectMethodMessage extends PaymentMessageBase {
  intentComponent: api.Assistant.IntentComponent.PaymentSelectMethod;
}

export interface PaymentConfirmedMessage extends PaymentMessageBase {
  intentComponent: api.Assistant.IntentComponent.PaymentConfirmed;
  data: {
    receipt: string;
    amountPaid: number;
    datePaid: Date;
    method: PaymentMethod;
  };
}

export type PaymentIntentMessage =
  | PaymentSelectMethodMessage
  | PaymentConfirmedMessage;
